import { createRouter, createWebHistory } from 'vue-router';

import ProjectsView from './pages/ProjectsView.vue';
import SearchView from './pages/SearchView.vue';
import SectorsView from './pages/SectorsView.vue';
import AboutView from './pages/AboutView.vue';
import Branding from './pages/Branding.vue';
import Animation from './components/Animation.vue';
import Homepage from './components/Homepage.vue';
import Careers from './components/Careers.vue';
import Career from './components/Career.vue';

var router = createRouter({
	history: createWebHistory(__dirname),
	routes: [
		{
			path: '/:lang/',
			component: Homepage
		},
		{
			path: '/:lang/animation',
			component: Animation
		},
		{
			path: '/:lang/projects',
			component: ProjectsView,
			name: 'projects-filter',
			props(route) {
				return {
					...route.params
				}
			}
		},
		{
			path: '/:lang/search',
			component: SearchView,
			props(route) {
				return {
					...route.params
				}
			}
		},
		{
			path: '/:lang/sectors',
			component: SectorsView,
			props: true,
		},
		{
			path: '/:lang/rolunk',
			component: AboutView,
			props: true
		},
		{
			path: '/:lang/munkatarsainkrol',
			component: AboutView,
			props: true
		},
		{
			path: '/:lang/munkatarsainkrol/:name',
			component: AboutView,
			props: true
		},
		{
			name: 'careers',
			path: '/:lang/karrier',
			component: Careers,
			props: true,
			// beforeEnter(to, from, next) {
			// 	next();
			// }
		},
		{
			name: 'career',
			path: '/:lang/karrier/:slug',
			component: Career,
			props: true,
			// beforeEnter(to, from, next) {
			// 	next();
			// }
		},
		{
			name: 'branding',
			path: '/:lang/branding',
			component: Branding,
			props: true,
			// beforeEnter(to, from, next) {
			// 	next();
			// }
		}
	]
});


/*
router.beforeEach((to, from, next) => {

	// if(!window.country && from.params.lang === undefined) {
	// 	// window.location.href = window.country.toLowerCase();
	// 	// router.push({ path: `/${window.country.toLowerCase() || 'en' }` })
	// } else {
	// }
	console.log(to, from, next);
	// if(to.matched.length === 0) console.log('Show 404');
	next();
});
router.afterEach((to, from ) => {
});
*/
export default router;
